module.exports = __webpack_public_path__ + "fonts/Inter-800-vietnamese75.5fc7f74.woff2";